import { createSlice } from '@reduxjs/toolkit';
import { getLocalStorageData, setLocalStorageData } from '../../utils/LocalStorage';

const authState = {
  isLoggedIn: false,
  ssoLoginFailure: false,
  loginDetail: {},
  currentUser: {
    username: '',
    userID: '',
    fullname: '',
    customerName: '',
    customerID: '',
    token: '',
  },
  qr_uri: '',
  isUpdating: false,
  error: false,
};

const getAuthState = () => {
  const auth = getLocalStorageData('token');
  try {
    const authobj = JSON.parse(auth);
    const { token, exp } = authobj.currentUser.token;
    return authobj;
  } catch (error) {
    return authState;
  }
};

const newAuth = getAuthState();

const authSlice = createSlice({
  name: 'auth',
  initialState: authState,
  reducers: {
    // LOGOUT_SUCCESS
    logoutSuccess: (state) => {
      // state.isLoggedIn = false
      localStorage.clear();
      sessionStorage.clear();
      localStorage.removeItem('persist:root');
      return authState;
    },
    setLoginDetail: (state, action) => {
      state.loginDetail = action.payload;
    },
    loginSuccess: (state, action) => {
      state.isLoggedIn = true;
      state.currentUser = action.payload;
      state.qr_uri = '';
      state.isUpdating = false;
      state.passed2FA = true;
      setLocalStorageData('token', JSON.stringify(state));
    },
    basicLoginSuccess: (state, action) => {
      state.isLoggedIn = true;
      state.currentUser = action.payload;
      state.qr_uri = '';
      state.isUpdating = false;
      state.passed2FA = false;
      setLocalStorageData('token', JSON.stringify(state));
    },
    setQrUri: (state, action) => {
      state.qr_uri = action.payload;
    },
    setCurrentUserUserName: (state, action) => {
      state.currentUser.username = action.payload;
    },
    setIsUpdating: (state, action) => {
      state.isUpdating = action.payload;
    },
    setSsoLoginFailure: (state, action) => {
      state.ssoLoginFailure = true;
      state.error = action.payload;
    },
    setLogout: (state, action) => {
      state = undefined;
    },
    setResetAuth: () => {
      return authState;
    },
    setRefreshToken: (state, action) => {
      console.log('setRefreshTokenabc', action.payload);
      state.currentUser.token.refresh = action.payload;
    },
  },
});

export const {
  logoutSuccess,
  loginSuccess,
  basicLoginSuccess,
  setQrUri,
  setCurrentUserUserName,
  setIsUpdating,
  setSsoLoginFailure,
  setLogout,
  setLoginDetail,
  setResetAuth,
  setRefreshToken,
} = authSlice.actions;

export default authSlice.reducer;
